import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";

const ResginationApproval = () => {

    // Dummy table data
    const dataSource = [
        {
            // key: "1",
            // employee_code: "EMP001",
            // employee_name: "John Doe",
            // date_of_joining: "2022-01-15",
            // date_of_resignation: "2025-02-01",
            // zone: "North",
            // branch_name: "Delhi",
            // department_name: "HR",
            // status: "Pending",
        },
    ];

    const columns = [
        {
            title: "S.No.",
            dataIndex: "employee_code",
            key: "employee_code",
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
        },
        {
            title: "Request Date",
            dataIndex: "date_of_joining",
            key: "date_of_joining",
        },
        {
            title: "Annual NP",
            dataIndex: "date_of_resignation",
            key: "date_of_resignation",
        },
        {
            title: "Releving Date as per policy",
            dataIndex: "zone",
            key: "zone",
        },
        {
            title: "Np Shortfall",
            dataIndex: "branch_name",
            key: "branch_name",
        },
        {
            title: "Reason",
            dataIndex: "department_name",
            key: "department_name",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Page Heading */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Resignation Approval</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.employeeDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Resignation</li>
                                <li className="breadcrumb-item active">
                                    Resignation Approval
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                {/* Card */}
                <div className="card">
                    <div className="card-header">
                        <div className="d-flex justify-content-between">
                            <h5 className="mb-0">Team Separation Request</h5>
                            {/* <Link
                                to="/resgination/add-form"
                                className="btn btn-primary custom_button d-flex align-items-center"
                            >
                                {" "}
                                Add
                            </Link> */}
                        </div>
                    </div>

                    <div className="card-body">
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            Selection={false}
                            showSearchInput={true}
                        />
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
                <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
            </div>
        </div>
    );
};

export default ResginationApproval;
